import {SummonDataProperty} from 'src/tracker/model/property/summon/summon-data-property'

export const odinProperty = new SummonDataProperty(
  "3750340d-3086-43da-89e3-81055f8f5330",
  "Odin",
)
